module.exports = __webpack_public_path__ + "img/美容.6c377ae6.jpg";